import Subcategory from '~/models/subcategory'
import { $axios } from '~/utils/api'

const getSubcategories = (): Promise<Subcategory[]> =>
  $axios.$get('/subcategories')

export { getSubcategories }
